import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, preventSelection, validateURL } from '../../lib/ep.js';
import { size as _size } from 'lodash';
import { HashRouter as Router, Route } from 'react-router-dom';

import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

import ActionButton, { BackButton, SecondaryButton, SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection';
import ColorPicker from '../builder/ColorPicker';
import { DeleteButton } from '../builder/ConfirmButton';
import DisabledArea from '../builder/DisabledArea';
import FieldLabel from '../builder/FieldLabel';
import FloatingLayer from '../builder/FloatingLayer';
import Input from '../builder/Input';
import InputWithButton from '../builder/InputWithButton';
import LabelSelector from '../labels/LabelSelector';
import Message, { AlertMessage } from '../builder/Message';
import Model from '../builder/Model';
import Range from '../builder/Range';
import RichEditor from '../builder/RichEditor';
import SaveButton from '../builder/SaveButton';
import SaveResponseMessage from '../builder/SaveResponseMessage';
import SectionSubtitle from '../builder/SectionSubtitle';
import SectionTitle from '../builder/SectionTitle';
import Select from '../builder/Select';
import TextArea from '../builder/TextArea';
import ToggleButton from '../builder/ToggleButton';
import Tooltip from '../builder/Tooltip';
import UrlField from '../builder/UrlField';

import SweepSidebar from './SweepSidebar';
import SweepParticipantsLayer from './SweepParticipantsLayer';
import DownloadFileOptions from '../backend/elements/DownloadFileOptions';

import { sweep as const_sweep } from './bootstrap';
import BuilderSubSectionTitle from '../backend/BuilderSubSectionTitle.js';
import RibbonCollection from '../ui_items/RibbonCollection.js';
import LinkCollection from '../ui_items/LinkCollection.js';
import Module from '../ui_items/Module.js';

const DragHandle = SortableHandle(() => <span class="sorter_target"></span>); // This can be any component you want

const SortableQuestions = SortableContainer(({items, field, intl, editQuestion, removeQuestion}) => {
	return (
		<div>
			{items.map((value, index) => {
				const obj_index = index;
				return (
					<SortableQuestion key={'sqitem-' + index} index={index} obj_index={obj_index} value={value} editQuestion={editQuestion} removeQuestion={removeQuestion} intl={intl} />
				)
			})}
		</div>
	);
});

const SortableQuestion = SortableElement(({value, obj_index, intl, editQuestion, removeQuestion}) => {
	return (
		<Question intl={intl} index={obj_index} {...value} editQuestion={editQuestion} removeQuestion={removeQuestion} sortable={true} />
	)}
);

const SortableAnswers = SortableContainer(({items, type_question, intl, editAnswer, removeAnswer, changeCorrectAnswer}) => {
	return (
		<div>
			{items.map((value, index) => {
				const obj_index = index;
				return (
					<SortableAnswer
						key={'saitem-' + index}
						index={index}
						type_question={type_question}
						obj_index={obj_index}
						value={value}
						editAnswer={editAnswer}
						removeAnswer={removeAnswer}
						changeCorrectAnswer={changeCorrectAnswer}
						intl={intl}
					/>
				)
			})}
		</div>
	);
});

const SortableAnswer = SortableElement(({value, obj_index, intl,type_question, editAnswer, removeAnswer, changeCorrectAnswer}) => {
	return (
		<Answer
			intl={intl}
			index={obj_index}
			answer={value}
			type_question={type_question}
			editAnswer={editAnswer}
			removeAnswer={removeAnswer}
			changeCorrectAnswer={changeCorrectAnswer}
			sortable={true}
		/>
	)}
);

const Answer = (props) => {
	const answer = props.answer;
	const index = props.index;

	return (
		<li class="gui_sortable_list_item gui_flexbox gui_flex_start gui_flex_nowrap gui_flex_align_center onZTop">
			<div class="item_header">
				<DragHandle />
				<div class="item_title_container" style={{maxWidth:'100%'}}>
					<ActionLink _class={{icon:'knk-number-' + (index + 1), other:'item_title cutTextOnOverflow gui_withoutEvents'}} autotranslate={false}><strong>{answer.text}</strong></ActionLink>
				</div>
			</div>

			<ButtonCollection _class={{other:'gui_is_padded_small'}}>
				{(props.type_question == 'quiz') && (
					<ToggleButton
						squared={true}
						active={(answer.checked)}
						onClick={() => props.changeCorrectAnswer(index)}
						color={(answer.checked) ? 'white' : null}
						icon='knk-on greenButton'
						icon_off='knk-off'
						_class={{first:true, other:((answer.checked) ? 'gui_withoutEvents' : '')}}
					/>
				)}

				<SquaredButton
					icon='knk-edit'
					onClick={() => props.editAnswer(index)}
					aria-label="Edit"
				/>

				<DeleteButton
					squared={true}
					_position="left"
					onClick={() => props.removeAnswer(index)}
					aria-label="Delete"
				/>
			</ButtonCollection>
		</li>
	)
}

const Question = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const question = props.q;
	const answers = props?.a ?? false;
	const index = props.index;

	let answer_ribbons = [];
	answers.map((answer, i) => {
		const is_quiz = (question.type == 'quiz') ? true : false;

		answer_ribbons.push({
			title:answer.text.toUpperCase(),
			color:(is_quiz && answer.checked) ? 'green' : 'gray',
			icon:(is_quiz) ? ((answer.checked) ? 'knk-on' : 'knk-off') : null,
		});
	});

	return (
		<li class="gui_sortable_list_item gui_flexbox gui_flex_start gui_flex_nowrap gui_flex_align_center">
			<div class="item_header" style={{height:'auto', minHeight:'40px'}}>
				<DragHandle />

				<div class="item_title_container" style={{maxWidth:'100%'}}>
					<ActionLink
						icon={`knk-number-${(index + 1)}`}
						_class={{ other:'item_title cutTextOnOverflow gui_withoutEvents' }}
						autotranslate={false}
					><strong>{question.text}</strong></ActionLink>

					<div style={{paddingLeft:'25px'}}>
						<div class="gui_flexbox_auto">
							<span class="gui_not_bordered gui_is_not_padded gui_not_in_end_small">{i18n("Answers")}:</span>

							<RibbonCollection
								items={answer_ribbons}
							/>
						</div>
					</div>
				</div>
			</div>

			<ButtonCollection _class={{other:'gui_is_padded_small'}} style={{flexBasis:'60px'}}>
				<SquaredButton
					icon='knk-edit'
					onClick={() => props.editQuestion(index)}
					aria-label="Edit"
				/>

				<DeleteButton
					squared={true}
					_position="left"
					onClick={() => props.removeQuestion(index)}
					aria-label="Delete"
				/>
			</ButtonCollection>
		</li>
	)
}

const Header = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const is_test = (props.is_test != undefined) ? props.is_test : false;
	const total_participants =  props.sweep.config?.total_participants ?? 0;

	return (
		<header class="gui_owner_header main_bg gui_is_padded_hi">
			<div class="gui_main_owner_header is_full_layout">
				<ul class="main_contents gui_full_width">
					<li class="gui_only_wide_screen">
						<div class={'gui_promo_type_icon medium_icon ' + props.icon} style={{background:props.color}}></div>
					</li>
					<li style={{flexGrow:'1'}}>
						{(props.has_started) ? (
							<h1 class="main_title gui_overflowed_auto" style={{maxHeight:'85px'}}>{props.sweep.title}</h1>
						) : (
							<div class="is_editable" onClick={() => props.togglePopupTitle()}>
								<h1 class="main_title editable_content gui_cutTextOnOverflow">{props.sweep.title}</h1>

								<SquaredButton
									icon='knk-edit'
									_class={{ other:'edit_this' }}
									aria-label="Edit"
								/>
							</div>
						)}

						<div class="gui_link_actions ribbons">
							{_size(props.organizers)>0 && props.sweep.label != undefined && (
								(props.sweep.label).map((label, j) => {
									return (
										<span key={j} class="linked_ribbon">
											<ActionLink
												icon='knk-edit'
												_class={{ other:'with_icon lightgrayBg main_text_color main_text_color_icon'}}
												onClick={() => props.togglePopupTitle()}
												autotranslate={false}
											>{label.name}</ActionLink>
										</span>
									)
								})
							)}
							<span class="ribbon lightgrayBg main_text_color promo_id">{i18n("ID")}: #{sweep.id}</span>
						</div>
						{(props.has_started && total_participants > 0) && (
							<div class="gui_flexbox_auto gui_flex_col">
								<div class="gui_total_participants gui_pos_rel">
									<div>
										<span>{props.sweep.config.total_participants} {vars.label_participants}</span>
										<ButtonCollection>
											<ActionLink
												_class={{other:'gui_in_end'}}
												onClick={() => props.toggleParticipants()}
											>View</ActionLink>

											{(parseInt(sweep.config.total_participants) <= const_sweep.LIMIT_EXPORT) && (<ActionLink _class={{other:'gui_in_end'}} onClick={() => props.toggleDownloadOptions()}>Export</ActionLink>)}
										</ButtonCollection>
									</div>
								</div>

								<AlertMessage
									_class={{ other:'redIcon' }}
								>
									<p>{i18n("This message is to inform you that your Event might have been finalized with no winners.")}</p>
								</AlertMessage>
							</div>
						)}
					</li>
				</ul>

				{(props.backPath != undefined && !props.has_started || props.no_sweep) && (
					<ButtonCollection _class={{other:'gui_not_in_start'}}>
						{(is_test) ? (
							<BackButton
								_href={props.backPath}
								autotranslate={false}
							>{i18n("Done!") + ' ' + i18n("Back to edit")}</BackButton>
						) : (
							(props.no_sweep) ? (
								<SaveButton
									type="confirm"
									confirmMessage="This event has ended without the random draw being made because there were fewer participants than prizes to be awarded. Do you want to start it over?"
									color="red"
									icon='knk-reload'
									onClick={(e, cb) => props.restart(cb)}
								>Restart</SaveButton>
							): (
								<BackButton
									_href={props.backPath}
								/>
							)
						)}
					</ButtonCollection>
				)}
			</div>
		</header>
	)
}

class SweepListLive extends Component {
	constructor(props, context) {

		const i18n = (m, c) => i18nIntl(m, props.intl, c);

		super(props, context);
		this.state = {
			answer_tmp:{
				checked:false,
				text:'',
			},
			answers_tmp:[],
			errors_answers:{},
			errors_form:{},
			errors_question:{},
			has_changes:false,
			display_popup_title:false,
			display_prizes_layer:false,
			display_question_layer:false,
			display_participants:false,
			display_download_options:false,
			display_save_message:false,
			display_save_status:false,
			organizers:props.organizers,
			payment_state:false,
			prize_name:'',
			prize_qty:1,
			question_tmp:{
				text:'',
				type:false,	//false or "poll"
			},
			used_prizes:0,
			show_alternates:false,
			sweep:this.props.sweep,
			type_question:'----',
			get_email:false,
			participants:[],
		};

		this.maxQuestions = 5;
		this.minAnswers = 2;
		this.maxAnswers = 6;
		this.maxPrizes = 8;

		this.activation_minimum = {
			20:{
				available:true,
				monthly_price:0,
				plan_name:"Free Plan",
				type:'free',
			},
			200:{
				available:((props.subsbasic) ? true : false),
				monthly_price:props.pricebasic,
				plan_name:"Basic Plan",
				type:'basic',
			},
			500:{
				available:((props.subspro) ? true : false),
				monthly_price:props.pricepro,
				plan_name:"Basic PRO Plan",
				type:'basicpro',
			},
			1000:{
				available:((props.subspremium) ? true : false),
				monthly_price:props.pricepremium,
				plan_name:"Premium Plan",
				type:'premium',
			},
			3000:{
				available:((props.subswl) ? true : false),
				monthly_price:props.pricewl,
				plan_name:"White Label Plan",
				type:'wl',
			},
			unlimited:{
				available:false,
				monthly_price:0,
				plan_name:"Contact us",
				type:'unknown',
			},
		};

		this.default_text_diclaimer = i18n("We promise that your email address is in good hands.") + " 😊\n\n" + i18n("We will only use it to send you information about ourselves and you can unsubscribe at any time. We are [Name of company] and our address is [Company address].") + "\n\n" + i18n("For more information, please read our Privacy Policy that you need to accept in order to enter the giveaway. Thank you!");
	}

	componentDidMount() {
		const limit_participants = (this.state.sweep.config.form.limit_participants != undefined) ? this.state.sweep.config.form.limit_participants : 20;
		this.state.payment_state = this.activation_minimum[limit_participants];

		if(this.state.sweep.config.prizes != undefined) {
			this.state.sweep.config.prizes.map((prize, i) => {
				this.state.used_prizes += parseInt(prize.qty);
			});
		}

		if(this.state.sweep.config.form.questions != undefined) {
			this.state.sweep.config.form.questions.map((question, i) => {
				this.state.type_question = question.q.type;
			});
		}

		if(this.state.sweep.config.form.email_disclaimer == undefined){
			this.state.sweep.config.form.email_disclaimer = this.default_text_diclaimer;
		}
		this.state.sweep.config.form.language = (this.state.sweep.config.form.language == undefined) ? (window.is_spanish ? 'spa' : 'eng') : this.state.sweep.config.form.language;

		this.validateForm();
		this.setState({...this.state});



		/*var max_range = false;
		$.each(this.activation_minimum, (i, item) => {
			if(item.available && max_range < i && i != 'unlimited') max_range = i;
		});

		this.changeForm('limit_participants', max_range);*/
	}

	change(k, v, name) {
		if(name != undefined) {
			this.state[name][k] = v;
			switch(name) {
				case 'question_tmp':
					if(k == 'text') {
						if(v != '') {
							this.state.errors_question[k] = "";
						} else {
							this.state.errors_question[k] = "This field is mandatory";
						}
					}
					break;
				case 'answer_tmp':
					if(k == 'text') {
						this.validateAnswerRepeat();
					}
					break;
			}
		} else {
			this.state[k] = v;
		}

		if(k == 'type_question' && v != this.state.question_tmp.type) {
			this.state.question_tmp.type = v;
			this.resetQuestion();
			this.resetAnswer();
			this.resetAnswers();

			if(v == '----' && _size(this.state.sweep.config.form.questions) > 0) {
				this.state.sweep.config.form.questions = [];
			}
		}

		this.state.has_changes = true;

		this.setState({...this.state});
	}

	changeState(k, v) {
		this.state[k] = v;
		this.setState({...this.state});
	}

	toggleParticipants() {
		this.state.display_participants = !this.state.display_participants;
		this.setState({...this.state});
	}
	toggleDownloadOptions() {
		this.state.display_download_options = !this.state.display_download_options;
		this.setState({...this.state});
	}

	changeSweep(k, v, name) {
		if(name != undefined) {
			this.state.sweep[name][k] = v;
		} else {
			this.state.sweep[k] = v;
		}
		this.state.has_changes = true;

		this.setState({...this.state});
	}

	save(cb) {
		var sweep = this.state.sweep;
		if(!this.props.subspremium)sweep.config.form.email_request = false;
		$.post('/sweeps/save/'+this.props.sweep.id, {sweep:JSON.stringify(sweep)}, (result) => {
			this.stateStatus(result);
			if(cb != undefined) cb(result);
		}, 'json');
	}

	restart(cb) {
		var sweep = this.state.sweep;
		$.post('/sweeps/restart/' + sweep.id, (result) => {
			this.stateStatus(result);
			if(result.status){
				delete this.state.sweep.config.form.start;
				delete this.state.sweep.config.form.end;
				this.setState({...this.state});
				window.location.hash = '#';
			}
			if(cb != undefined) cb();
		}, 'json');
	}

	stateStatus(result) {
		this.state.display_save_status = (result.status) ? 'ok' : 'ko';
		this.state.display_save_message = result.message;
		this.state.has_changes = (!result.status) ? true : false;
		this.state.display_popup_title = false;
		if(result.sweep!=undefined) this.state.sweep = result.sweep;

		this.setState({...this.state});
		setTimeout(function() {
			this.state.display_save_status = false;
			this.state.display_save_message = false;
			this.setState({...this.state});
		}.bind(this), 2500);
	}


	validateForm(){
		this.state.errors_form = {};
		var sweep_form = this.state.sweep.config.form;

		if(sweep_form['name'] == undefined || sweep_form['name'].length == 0) {
			this.state.errors_form['name'] = "This field is mandatory";
		} else {
			this.state.errors_form['name'] = (sweep_form['name'].length < 3) ? "This field is too short" : null;
		}

		sweep_form['email_request'] = sweep_form['email_request'] != undefined && (sweep_form['email_request'] == "true" || sweep_form['email_request'] == true)? true : false;
		if(sweep_form['email_request']){
			this.state.errors_form['email_policy'] = !validateURL(sweep_form['email_policy']) ? "Wrong url format" : null;
			if(sweep_form['email_disclaimer'] == undefined || sweep_form['email_disclaimer'].length == 0) {
				this.state.errors_form['email_disclaimer'] = "This field is mandatory";
			} else {
				this.state.errors_form['email_disclaimer'] = (sweep_form['email_disclaimer'].length < 3) ? "This field is too short" : null;
			}
		}
		this.setState({...this.state});
	}

	changeForm(k, v) {
		if(k == 'seconds') {
			v = (v == '') ? 0 : v * 60;
		}

		if(k == 'limit_participants') {
			this.state.payment_state = this.activation_minimum[v];
		}
		this.state.sweep.config.form[k] = v;
		this.setState({...this.state});
		this.state.has_changes = true;
		this.validateForm();
	}

	togglePopupTitle() {
		this.state.display_popup_title = !this.state.display_popup_title;
		this.setState({...this.state});
	}

	toggleTestBefore(cb) {
		this.state.display_test_before = !this.state.display_test_before;
		this.setState({...this.state});
		if(cb != undefined) cb();
	}

	/* QUESTIONS - ini */
	openQuestionLayer() {
		this.state.display_question_layer = true;
		this.resetQuestion();
		this.resetAnswer();
		this.resetAnswers();
		this.setState({...this.state});
	}

	createOrEditQuestion(cb) {
		var sweep = this.state.sweep;
		var question = {};
		question.q = this.state.question_tmp;
		if(_size(this.state.answers_tmp) > 0) question.a = this.state.answers_tmp;

		var is_update = false;
		var questions = (sweep.config.form.questions != undefined) ? sweep.config.form.questions : [];
		if(question.q.index!=undefined){
			const index_update_question = question.q.index;
			delete question.q.index;
			questions[index_update_question] = question;
			is_update = true;
		}else{
			questions.push(question);
		}
		sweep.config.form.questions = questions;

		this.state.sweep = sweep;
		this.state.display_question_layer = false;
		this.resetQuestion();
		this.resetAnswers();
		this.resetAnswer();
		this.setState({...this.state});
		if(is_update){
			this.save();
		}
		if(cb != undefined) cb();
	}

	removeQuestion(index) {
		this.state.has_changes = true;
		this.state.sweep.config.form.questions.splice(index, 1);
		this.setState({...this.state});
	}

	resetQuestion() {
		this.state.question_tmp = {
			text:'',
			type:this.state.type_question,
		};
		this.state.errors_question.text = "This field is mandatory";
	}

	editQuestion(index) {
		var sweep = this.state.sweep;
		var questions = (sweep.config.form.questions != undefined) ? sweep.config.form.questions : [];

		this.state.question_tmp = questions[index].q;
		this.state.question_tmp.index = index;
		this.state.answers_tmp = questions[index].a;
		this.state.display_question_layer = true;
		this.state.errors_question.text = '';
		this.setState({...this.state});
	}

	validateAnswerRepeat() {
		var is_repeated = false;
		if(_size(this.state.answers_tmp) > 0) {
			this.state.answers_tmp.map((answer, i) => {
				if(!is_repeated && this.state.answer_tmp.text == answer.text && i!=answer.index) {
					is_repeated = true;
				}
			});
		}

		this.state.errors_answers.text = (is_repeated) ? "Repeated value" : "";

		return is_repeated;
	}

	validateHasCorrectAnswer() {
		var has_correct_answer = false;

		this.state.answers_tmp.map((answer, i) => {
			if(!has_correct_answer) has_correct_answer = (answer.checked) ? true : false;
		});

		return has_correct_answer;
	}

	createOrEditAnswer(index) {
		if(!this.validateAnswerRepeat()) {
			this.state.errors_answers.text = null;
			if(this.state.answer_tmp.index!=undefined){
				this.state.answers_tmp[index] = this.state.answer_tmp;
			}else{
				this.state.answers_tmp.push(this.state.answer_tmp);
			}
			this.resetAnswer();
		}
		this.setState({...this.state});
	}

	changeCorrectAnswer(i) {
		this.state.answers_tmp.map((answer, k) => {
			this.state.answers_tmp[k].checked = (k == i) ? true : false;
		});
		this.setState({...this.state});
	}

	editAnswer(index) {
		this.state.answer_tmp = this.state.answers_tmp[index];
		this.state.answer_tmp.index = index;
		this.setState({...this.state});
	}

	resetAnswer() {
		this.state.answer_tmp = {
			text:'',
			checked:false,
		};
	}

	resetAnswers() {
		this.state.answers_tmp = [];
	}

	removeAnswer(index) {
		this.state.answers_tmp.splice(index, 1);
		this.setState({...this.state});
	}
	/* QUESTIONS - end */

	/* PRIZES - ini */
	totalPrizes() {
		var cfg = this.state.sweep.config;

		var num_winners = 0;
		cfg.prizes.map((prize, i) => {
			num_winners += parseInt(prize.qty);
		});
		cfg.num_winners = num_winners;

		this.state.used_prizes = num_winners;

		this.state.sweep.config = cfg;
		this.state.has_changes = true;
		this.setState({...this.state});
	}

	createPrize(cb) {
		var cfg = this.state.sweep.config;
		const name = this.state.prize_name;
		const qty = this.state.prize_qty;

		if(name != '' && qty > 0) {
			if(cfg.prizes == undefined) {
				cfg.prizes = [];
			}

			cfg.prizes.push({
				name:name,
				qty:qty,
			});

			this.state.prize_name = '';
			this.state.prize_qty = 1;

			this.totalPrizes();
		}

		if(cb != undefined) cb();
	}

	removePrize(index) {
		var prizes = this.state.sweep.config.prizes;

		prizes.splice(index, 1);
		this.state.sweep.config.prizes = prizes;
		this.totalPrizes();
	}
	/* PRIZES - end */

	activate(cb) {
		this.state.sweep.click_activate = true;
		if(this.state.sweep.payment_id == const_sweep.PAYMENT_TESTMODE)this.state.sweep.payment_id = null;
		this.save((response) => {
			if(response.status){
				this.toggleTestBefore(()=>{
					window.location.hash = 'confirm';
				});
			}
			if(cb != undefined) cb();
		});
	}

	testIt(cb) {
		this.state.sweep.click_activate = true;
		this.state.sweep.payment_id = const_sweep.PAYMENT_TESTMODE;
		this.save((response) => {
			if(response.status){
				this.state.sweep.payment_id = null;
				window.location.hash = 'confirm_test';
			}
			if(cb != undefined) cb();
		});
	}

	onSortEnd = ({oldIndex, newIndex}) => {
		var sweep = this.state.sweep;
		var questions = (sweep.config.form.questions != undefined) ? sweep.config.form.questions : [];

		const question_old = questions[oldIndex];
		const question_new = questions[newIndex];

		questions[oldIndex] = question_new;
		questions[newIndex] = question_old;
		this.state.sweep.config.form.questions = questions;
		this.save();
	};


	onSortEndAnswers = ({oldIndex, newIndex}) => {
		var answers = this.state.answers_tmp;

		const answer_old = answers[oldIndex];
		const answer_new = answers[newIndex];

		answers[oldIndex] = answer_new;
		answers[newIndex] = answer_old;
		this.setState({...this.state});
	};

	setLabelSweep(label){
		if(label!=undefined){
			this.state.sweep.label = [];
			this.state.sweep.label.push(label);

			const label_exist = this.state.organizers.filter((obj)=>{return obj.id == label.id})[0];
			if(!label_exist){
				//when create, already assigned
				this.state.organizers.push(label);
				this.state.display_popup_title = false;
			}
			this.setState({...this.state});
		}
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const vars = (this.props.vars != undefined) ? this.props.vars : {};
		const sweep_config = this.state.sweep.config;
		const sweep_form = sweep_config.form;

		/* QUESTIONS - ini */
		const options_question = [
			{
				k:'----',
				v:"No",
			},
			{
				k:'survey',
				v:"Yes, survey mode",
			},
			{
				k:'quiz',
				v:"Yes, quiz mode",
			},
		];

		const options_email = [
			{
				k:false,
				v:"No",
			},
			{
				k:true,
				v:"Yes",
			}
		];

		const questions = (sweep_form.questions != undefined) ? sweep_form.questions : [];
		const enable_exclusions_rules = (this.state.type_question == 'quiz' && _size(questions) > 0) ? true : false;
		/* QUESTIONS - end */

		/* PRIZES - ini */
		const prizes = (this.state.sweep.config.prizes != undefined) ? this.state.sweep.config.prizes : [];
		const available_add_prize = (this.state.used_prizes < this.maxPrizes) ? true : false;
		/* PRIZES - end */

		const participants_range = [
			{
				k:'20',
				v:"20 (" + i18n("Free") + ")",
			},
			{
				k:'200',
				v:"200 (" + i18n("Basic Plan") + ")",
			},
			{
				k:'500',
				v:"500 (" + i18n("Basic PRO Plan") + ")",
			},
			{
				k:'1000',
				v:"1000 (" + i18n("Premium Plan") + ")",
			},
			{
				k:'3000',
				v:"3000 (" + i18n("White Label Plan") + ")",
			},
			{
				k:'unlimited',
				v:"> 3000 (" + i18n("Contact us") + ")",
			},
		];

		const languages = [
			{
				k:'spa',
				v:i18n("Spanish"),
			},
			{
				k:'eng',
				v:i18n("English"),
			}
		];

		const has_question_text = (this.state.question_tmp.text != '') ? true : false;
		const has_minimum_answers = (_size(this.state.answers_tmp) >= this.minAnswers) ? true : false;
		const has_correct_answer = (this.validateHasCorrectAnswer()) ? true : false;
		const has_repeated_answer = (this.validateAnswerRepeat()) ? true : false;
		const has_answer_correct_enabled = (this.state.type_question == 'quiz') ? true : false;
		const editing_answer = (this.state.answer_tmp.index != undefined) ? true : false;

		var create_question_enabled = (has_question_text && (!has_answer_correct_enabled || has_correct_answer) && has_minimum_answers && !has_repeated_answer && !editing_answer) ? true : false;
		var error_question_create_msg = "";
		if(!has_question_text) {
			error_question_create_msg = "The question text is mandatory";
		} else if(!has_minimum_answers) {
			error_question_create_msg = "A minimum of 2 answers is required";
		} else if(has_answer_correct_enabled && !has_correct_answer) {
			error_question_create_msg = "A correct answer must be defined";
		} else if(has_repeated_answer) {
			error_question_create_msg = "Repeated value";
		} else if(editing_answer) {
			error_question_create_msg = "First, save the answer";
		}
		const has_started = (sweep_form.start != undefined) ? true : false;
		
		const header_props = {
			color:vars.color_code,
			icon:this.props.type.icon_class,
			intl:this.props.intl,
			has_started: has_started,
			no_sweep: has_started && sweep_config.num_winners > sweep_config.total_participants && sweep_config.total_participants>0 ? true : false,
			restart:this.restart.bind(this),
			toggleParticipants:this.toggleParticipants.bind(this),
			toggleDownloadOptions:this.toggleDownloadOptions.bind(this),
			sweep:this.state.sweep,
			organizers:this.state.organizers,
		};

		var item_label = {};//for label selector
		item_label.label_id = this.state.sweep.label!=undefined ? this.state.sweep.label[0].id : '';
		item_label.sweep_id = this.state.sweep.id;

		const disable_create_prizes = this.maxPrizes<=this.state.used_prizes ? true : false;

		const avail_downloads = [
			{ label:i18n("Entrants"), url:window.panel_url+'sweeps/export/'+sweep.id+'?download=true', icon:'knk-users', xls:{enabled:true, utf8:true, iso:true}, csv:{enabled:true, utf8:true, iso:false} },
		];


		return (
			<Router hashType="noslash">
				<div class="promo_profile profile_grid gui_grid without_menu">
					<Route path="(/|/log)" exact={true} render={(route) => {
						if(sweep_form != undefined && sweep_form.start != undefined && window.location.hash != '#log') window.location.hash = 'confirm';

						var available_add_question = true;
						var available_add_question_label = "";
						if(!this.state.type_question || this.state.type_question == '----') {
							available_add_question = false;
							available_add_question_label = "No question mode is selected";
						} else if(_size(questions) == this.maxQuestions) {
							available_add_question = false;
							available_add_question_label = "Limit of questions reached";
						}

						/* CAN CONTINUE? - ini */
						const has_payment_passed = (this.state.payment_state.available) ? true : false;
						const has_prizes_passed = (_size(prizes) > 0) ? true : false;
						const has_quiz = (this.state.type_question != '----') ? true : false;
						const has_questions_passed = (_size(questions) > 0) ? true : false;
						const has_form_field_passed = (this.state.errors_form.name == undefined) ? true : false;
						const has_requested_email = (sweep_form.email_request != undefined) ? sweep_form.email_request : false;
						const has_error_email_policy = (has_requested_email && this.state.errors_form['email_policy']) ? true : false;
						const has_error_email_disclaimer = (has_requested_email && this.state.errors_form['email_disclaimer']) ? true : false;

						const available_activation = (has_payment_passed && has_prizes_passed && (has_questions_passed || !has_quiz) && has_form_field_passed && !has_error_email_policy && !has_error_email_disclaimer) ? true : false;

						var error_activation_msg = "";
						var activate_button_label = "Activate";
						if(!has_form_field_passed) {
							error_activation_msg = "The identification field is mandatory";
						} else if(!has_payment_passed) {
							error_activation_msg = "Your plan can't use this limit of participants";
							//activate_button_label = "Need plan";
						} else if(has_quiz && !has_questions_passed) {
							error_activation_msg = "You need to define, at least, one question";
						} else if(!has_prizes_passed) {
							error_activation_msg = "You need to define, at least, one prize";
						} else if(has_error_email_policy) {
							error_activation_msg = "The policy url field is mandatory";
						} else if(has_error_email_disclaimer) {
							error_activation_msg = "The disclaimer field is mandatory";
						}
						/* CAN CONTINUE? - end */

						return (
							<section class="with_aisled_content_blocks">
								<Header {...header_props} togglePopupTitle={() => this.togglePopupTitle()}></Header>

								<div class="gui_aisled_content_blocks">
									<section class="gui_is_padded_hi main_bg">
										<div class="gui_section_header alone_section_header cleared_header">
											<SectionTitle _class={{in_top:true}} autotranslate={false}>{i18n("Participation form")}</SectionTitle>
										</div>

										<SectionSubtitle _class={{in_top:true}}>To participate, users should scan the QR code or access the URL on the presentation screen with their mobile phones. They'll be sent to the participation form. First, they identify themselves with their name or nickname. Then they answer some multiple-choice questions (you don't have to include questions if you don't want to).</SectionSubtitle>

										<Model model={sweep_form} change={(k, v) => this.changeForm(k, v)} errors={this.state.errors_form}>
											<Input
												_class={{size:50}}
												name="name"
												error_msg_position_class="is_floating"
												placeholder="i.e. Full name"
												label_props={{
													tooltip:<Tooltip>This field is used to identify individual participants. The information they enter will be projected on the main screen alongside their unique number in the prize draw. Do not ask for private information such as e-mails or social security numbers.</Tooltip>,
												}}
											>Title for identification field</Input>
										</Model>

										<DisabledArea disabled={(has_questions_passed) ? true : false} message="You can only change this if you don't have any questions created yet. First, remove all the questions.">
											<Model model={this.state} change={(k, v) => this.change(k, v)}>
												<Select
													_class={{size:50}}
													values={options_question}
													name="type_question"
													label_props={{
														tooltip:<Tooltip>Add multiple-choice questions to make the contest more exciting. Survey mode: collect and share participants' feedback on the main screen. Quiz mode: test participants' knowledge and limit the giveaway to those who answer correctly.</Tooltip>,
													}}
												>Do you want to ask the participants some questions?</Select>
											</Model>
										</DisabledArea>

										{(this.state.type_question != '----') && (
											<div style={{ marginBlockStart:'1.8em' }}>
												<FieldLabel
													_class={{other:'without_colon'}}
													_extra_component={(available_add_question) ? <ActionLink onClick={() => this.openQuestionLayer()}>Add question</ActionLink> : null}
													addition={`${_size(questions)}/${this.maxQuestions}`}
												>Questions</FieldLabel>

												{(has_questions_passed) && (
													<ul class="gui_sortable_list gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap">
														<SortableQuestions
															items={questions}
															intl={this.props.intl}
															editQuestion={(index) => this.editQuestion(index)}
															removeQuestion={(index) => this.removeQuestion(index)}
															onSortStart={() => preventSelection(true)}
															onSortEnd={this.onSortEnd}
															useDragHandle={true}
														/>
													</ul>
												)}
											</div>
										)}

										<DisabledArea disabled={(!this.props.subspremium) ? true : false} message="This option is only available for clients with a Premium or White Label plan.">
											<Select
												_class={{size:50}}
												values={options_email}
												model={sweep_form}
												change={(k, v) => this.changeForm(k, v)}
												name="email_request"
												label_props={{
													tooltip:<Tooltip>Recommended for B2B events.</Tooltip>,
												}}
											>Do you want to collect the participants' email addresses?</Select>
										</DisabledArea>

										{(sweep_form.email_request) && (
											<Model model={sweep_form} change={this.changeForm.bind(this)} errors={this.state.errors_form}>
												<RichEditor
													name="email_disclaimer"
													display_wysiwyg_buttons={false}
													has_emojis={true}
													_class={{size:50}}
													label_props={{
														_class:{ other:'without_colon' },
														_extra_component:<div class="gui_small_text gui_not_in_start_small gui_not_in_end_small">{i18n("This is the text that participants will see under the email field. Tell them what will you do with their email, that they can unsubscribe at any time and identify clearly who you are. You can use the text that we propose.")}</div>,
														autotranslate:false,
														extra_contents_whole:true,
													}}
													>{`${i18n("Disclaimer")} (${i18n("Mandatory")}):`}</RichEditor>

												<UrlField
													name="email_policy"
													error_msg_position_class="is_floating"
													_class={{size:50}}
													label_props={{
														_class:{ other:'without_colon' },
														_extra_component:<div class="gui_small_text gui_not_in_start_small gui_not_in_end_small"><FormattedMessage id="You can select or create one from {link} (privacy policy template included)" values={{link:<ActionLink _href={window.panel_url+'terms'} _target="_blank">our legal texts editor</ActionLink>}} /></div>,
														autotranslate:false,
														extra_contents_whole:true,
													}}
												>{`${i18n("Link to your privacy policy")} (${i18n("Mandatory")}):`}</UrlField>
											</Model>
										)}
									</section>

									<section class="gui_is_padded_hi main_bg">
										<div class="gui_section_header alone_section_header cleared_header">
											<SectionTitle _class={{in_top:true}} autotranslate={false}>{i18n("Prizes")} ({this.state.used_prizes}/{this.maxPrizes})</SectionTitle>

											<ButtonCollection>
												<ActionButton
													onClick={() => this.setState({ display_prizes_layer:true })}
												>Manage prizes</ActionButton>
											</ButtonCollection>
										</div>

										{(this.state.type_question == 'quiz') && (
											<Message>
												<p>{i18n("Participants will only enter the prize draw if they get all the questions correct.")}</p>
												<p>{i18n("If there are fewer finalists than prizes, the system will not run a giveaway. Instead, you'll see a top 10 ranking of participants, based on their correct answers and speed of response. Give out the prizes according to the ranking.")}</p>
											</Message>
										)}

										<div class="gui_pos_rel">
											{(has_prizes_passed) && (
												<ul>
													{prizes.map((prize, i) => {
														return (
															<li key={i}>
																{prize.qty} × <strong>{prize.name}</strong>
															</li>
														)
													})}
												</ul>
											)}
										</div>
									</section>

									<section class="gui_is_padded_hi main_bg">
										<div class="gui_section_header alone_section_header cleared_header">
											<SectionTitle _class={{in_top:true}}>Settings</SectionTitle>
										</div>

										<div class="gui_flexbox_auto gui_flex_col gui_flex_nowrap">
											<Model model={sweep_form} change={(k, v) => this.changeForm(k, v)} errors={this.state.errors}>
												<Range
													_class={{size:40}}
													min={1}
													max={5}
													_extra="In minutes"
													name="seconds"
													step={1}
													value={sweep_form.seconds / 60}
												>Available time for registering</Range>

												<ColorPicker
													_class={{size:40}}
													color={sweep_form.main_color}
													name="main_color"
												>Main color</ColorPicker>

												<Select
													_class={{size:40}}
													values={languages}
													name="language"
												>Language</Select>

												<Select
													_class={{size:40}}
													values={participants_range}
													name="limit_participants"
												>How many participants do you want, at most?</Select>
											</Model>
										</div>

										{(this.state.payment_state && !this.state.payment_state.available) && (
											<div>
												{(this.state.payment_state.type != 'unknown') ? (
													<AlertMessage
														title="Activate a Plan"
														_class={{ other:'in_bottom' }}
													>
														<p><FormattedMessage id="You need an active {plan} to run this giveaway." values={{plan:<strong>{i18n(this.state.payment_state.plan_name)} ({this.state.payment_state.monthly_price})</strong>}} /></p>

														<ActionLink
															onClick={(e, cb) => this.save(() => { window.location.href = `/plans/add/${this.state.payment_state.type}`; })}
														>Activate this plan</ActionLink>
													</AlertMessage>
												) : (
													<AlertMessage
														title="Not available"
														_class={{ other:'in_bottom' }}
													>
														<ActionLink
															onClick={(e, cb) => this.save(() => { window.location.href = `mailto:${i18n("hello@easypromosapp.com")}?subject=${i18n("I want to create a bigger sweeps live event")}&body=${i18n("Can you help me?")}` })}
														>Contact us</ActionLink>
													</AlertMessage>
												)}
											</div>
										)}

										<ButtonCollection _class={{other:'gui_flex_end not_in_top'}}>
											<SaveButton
												disabled={(!this.state.has_changes) ? true : false}
												onClick={(e, cb) => this.save(cb)}
											>Save changes</SaveButton>

											<SaveButton
												error_msg={error_activation_msg}
												onClick={(e, cb) => this.testIt(cb)}
												secondary={true}
												autotranslate={false}
												disabled={(!available_activation) ? true : false}
												tooltip={(!available_activation) ? <Tooltip position='top' with_icon={false}>{error_activation_msg}</Tooltip> : <Tooltip position='top' with_icon={false} autotranslate={false}>{`${i18n("Run a test to check the giveaway works and preview how it appears onscreen. Participate to test the user experience.")}<br /><br />${i18n("Test and edit the giveaway as much as you need.")}<br /><br />${i18n("When you're ready for the event, click Activate to get the giveaway URL and project it on the big screen.")}`}</Tooltip>}
											>{i18n("Test it!")}</SaveButton>

											<ActionButton
												error_msg={error_activation_msg}
												time="200"
												disabled={(!available_activation) ? true : false}
												tooltip={(!available_activation) ? <Tooltip position='top' with_icon={false}>{error_activation_msg}</Tooltip> : null}
												onClick={() => this.toggleTestBefore()}
											>{activate_button_label}</ActionButton>
										</ButtonCollection>
									</section>
								</div>

								{(this.state.display_test_before) && (
									<FloatingLayer _class={{size:'small'}} backButton={() => this.toggleTestBefore()}>
										<div>
											<SectionTitle _class={{icon:'knk-on'}}>Activation</SectionTitle>
											<p>{i18n("Have you run a test yet? We recommend testing your giveaway before the event, to make sure everything's working as it should.")}</p><br/>
											<p>{i18n("Click Continue to get the URL to project your giveaway onscreen, and the remote control URL to manage the giveaway on stage.")}</p><br/>
											<p>{i18n("You can still edit the giveaway, right up until you begin the contest on the event screen.")}</p>

											<ButtonCollection in_floating={true} _class={{other:'gui_ali'}}>
												<SaveButton
													onClick={(e, cb) => this.activate(cb)}
												>Continue</SaveButton>

												<SecondaryButton
													onClick={() => this.toggleTestBefore()}
												>Cancel</SecondaryButton>
											</ButtonCollection>
										</div>
									</FloatingLayer>
								)}
							</section>
						)
					}} />

					<Route path="/(confirm|confirm_test)" exact={true} render={(route) => {
						const is_test = route.match.url == '/confirm_test' ? true : false;

						const projection_url = this.state.sweep.projection_url + ((is_test) ? '?mode=test' : '');

						return (
							<section class="with_aisled_content_blocks">
								<Header {...header_props} is_test={is_test} togglePopupTitle={() => this.togglePopupTitle()} backPath={(is_test) ? '#' : '#'}></Header>

								<div class="gui_aisled_content_blocks">
									<Module _class={(is_test) ? { other:'is_test' } : null}>
										<SectionTitle _class={{in_top:true}} autotranslate={false}>{i18n("Main Screen URL")}{(is_test) && (
											<span class="redColor gui_not_in_start_tiny">[TEST]</span>
										)}</SectionTitle>

										<SectionSubtitle>Use this URL to project the giveaway on the main screen at your event. Open it in a browser on the device connected to the screen, in horizontal mode (for example 16:9).</SectionSubtitle>

										<LinkCollection
											items={[{
												urls:[{
													url:projection_url,
												}, {
													url:sweep_form.short_projection_link,
													pre_extra:<RibbonCollection
														items={[{
															title:"Short URL",
															color:'gray',
														}]}
													/>,
													_class:{ other:'gui_not_in_start' },
												}],
											}]}
											_class={(is_test) ? { other:'is_test' } : null}
										/>
									</Module>

									<Module _class={(is_test) ? { other:'is_test' } : null}>
										<SectionTitle _class={{in_top:true}} autotranslate={false}>{i18n("Remote Control URL")} ({i18n("Optional", 'lowercase')}){(is_test) && (
											<span class="redColor gui_not_in_start_tiny">[TEST]</span>
										)}</SectionTitle>
										<SectionSubtitle>Use this URL if you want to control the giveaway from a separate device (for example, the presenter's mobile phone). Recommended for presentations where the projecting device is not accessible from the stage.</SectionSubtitle>

										<Message
											_class={{ other:'in_top' }}
										>
											<p>{i18n("In order to control the projection with the Remote Control URL, the Main Screen URL must already be open.")}</p>
										</Message>

										<LinkCollection
											items={[{
												urls:[{
													url:`${projection_url}#manage`,
												}, {
													url:sweep_form?.short_manage_link ?? null,
													pre_extra:<RibbonCollection
														items={[{
															title:"Short URL",
															color:'gray',
														}]}
													/>,
													_class:{ other:'gui_not_in_start' },
												}],
												extra:<span class="gui_not_in_top_tiny">{i18n("Remote Control key")}: <strong class="gui_not_in_start_tiny">{sweep_form.manage_number}</strong></span>,
												qr:`${this.state.sweep.projection_url}#manage`,
											}]}
											_class={{ other:`with_qr${(is_test) ? ' is_test' : ''}` }}
										/>
									</Module>
								</div>

								{(this.state.display_participants) && (
									<SweepParticipantsLayer
										roles={this.props.roles}
										limit_show={(!this.props.subspro) ? const_sweep.LIMIT_SUBSCRIPTION_PRO : const_sweep.LIMIT_INFINITE}
										back={this.toggleParticipants.bind(this)}
										toggleDownloadOptions={this.toggleDownloadOptions.bind(this)}
										participants_photo={{}}
										stateStatus={(e, r) => this.stateStatus(r)}
										sweep={this.props.sweep}
										participants={this.state.participants}
										save={this.save.bind(this)}
									/>
								)}

								{(this.state.display_download_options) && (
									<DownloadFileOptions
										downloads={avail_downloads}
										close={()=> this.toggleDownloadOptions()}
									/>
								)}
							</section>
						)
					}} />

					{(this.state.display_question_layer) && (
						<FloatingLayer _class={{size:'small'}} backButton={() => this.setState({ display_question_layer:false })}>
							<div>
								<SectionTitle autotranslate={false}>{i18n("Create a new question")} ({_size(questions) + 1}/{this.maxQuestions})</SectionTitle>

								<Model model={this.state.question_tmp} change={(k, v) => this.change(k, v,'question_tmp')} errors={this.state.errors_question}>
									<RichEditor
										name="text"
										display_wysiwyg_buttons={false}
										has_emojis={true}
										_class={{first:true, v_size:'small'}}
										max_length={100}
									>Question text</RichEditor>
								</Model>

								<div class="gui_not_in_top_big">
									<BuilderSubSectionTitle
										title={`${i18n("Answers")} (${_size(this.state.answers_tmp)}/${this.maxAnswers})`}
									/>

									<div>
										<div class="gui_not_in_top_tiny gui_not_in_bottom_tiny">
											{(_size(this.state.answers_tmp) < this.maxAnswers || this.state.answer_tmp.index != undefined) && (
												<div class="gui_flexbox">
													<Model
														model={this.state.answer_tmp}
														change={(k, v) => this.change(k, v, 'answer_tmp')}
														errors={this.state.errors_answers}
													>
														<InputWithButton
															has_emojis={true}
															_class={{ first:true }}
															submitColor="main"
															submitIcon={(this.state.answer_tmp.index != undefined) ? 'knk-save' : 'knk-add-item'}
															name="text"
															error_msg_position_class="is_floating"
															placeholder={i18n("Answer text")}
															max_length={30}
															onSubmit={() => this.createOrEditAnswer()}
														/>
													</Model>
												</div>
											)}
										</div>

										{(_size(this.state.answers_tmp) > 0) && (
											<DisabledArea
												disabled={this.state.answer_tmp.index != undefined}
												message="While editing an item, this is disabled"
											>
												<ul class="gui_sortable_list gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap">
													<SortableAnswers
														items={this.state.answers_tmp}
														type_question={this.state.question_tmp.type}
														intl={this.props.intl}
														editAnswer={(index) => this.editAnswer(index)}
														removeAnswer={(index) => this.removeAnswer(index)}
														changeCorrectAnswer={(index) => this.changeCorrectAnswer(index)}
														onSortStart={() => preventSelection(true)}
														onSortEnd={this.onSortEndAnswers}
														useDragHandle={true}
													/>
												</ul>
											</DisabledArea>
										)}
									</div>
								</div>

								<ButtonCollection in_floating={true}>
									<SaveButton
										disabled={(create_question_enabled) ? false : true}
										error_msg={error_question_create_msg}
										tooltip={(!create_question_enabled) ? <Tooltip position='top' with_icon={false}>Please, fill in all the fields above and mark one correct answer.</Tooltip> : null}
										onClick={(e, cb) => this.createOrEditQuestion(cb)}
									>Save</SaveButton>

									<SecondaryButton
										onClick={() => this.setState({ display_question_layer:false })}
									>Close</SecondaryButton>

									{(this.state.type_question == 'quiz' && !has_correct_answer && _size(this.state.answers_tmp) > 2) && (
										<AlertMessage
											title="Click the X to mark the correct answer."
											_class={{ other:'in_top in_bottom' }}
										/>
									)}
								</ButtonCollection>
							</div>
						</FloatingLayer>
					)}

					{(this.state.display_prizes_layer) && (
						<FloatingLayer backButton={() => this.setState({ display_prizes_layer:false })}>
							<div>
								<SectionTitle>Define the prize(s)</SectionTitle>

								<div class="gui_equal_columns gui_padded_children">
									<div class="gui_flexbox_auto gui_flex_col gui_flex_nowrap">
										<DisabledArea disabled={(!available_add_prize) ? true : false} message="Limit of prizes reached">
											<Model model={this.state} change={(k, v) => this.changeState(k, v)}>
												<Input
													name="prize_name"
													_class={{first:true}}
													max_length="30"
													placeholder="Marvelous prize"
													label_props={{
														extra_contents:i18n("Written in singular"),
													}}
												>Prize Name</Input>

												<Input
													name="prize_qty"
													_type="number"
													min="1"
													max={this.maxPrizes - this.state.used_prizes}
													_class={{size:30}}
													placeholder="1"
												>Quantity</Input>
											</Model>

											<ButtonCollection _class={{other:'not_in_top gui_flex_end'}}>
												<SaveButton
													onClick={(e, cb) => this.createPrize(cb)}
												>Add prize</SaveButton>
											</ButtonCollection>
										</DisabledArea>
									</div>

									<div class="gui_not_in_bottom">
										{(_.size(this.state.sweep.config.prizes) > 0) && (
											<ul>
												{this.state.sweep.config.prizes.map((prize, i) => {
													return (
														<li key={'prize_'+i} class="gui_flexbox_auto gui_flex_nowrap gui_padded_children_low gui_not_in_bottom_tiny gui_not_padded_in_bottom_tiny gui_bordered_bottom">
															<div class="gui_flexbox gui_flex_nowrap gui_pos_rel gui_flex_align_center" style={{flexGrow:'1'}}>
																<div class="gui_cutTextOnOverflow">{prize.qty} × <strong>{prize.name}</strong></div>
															</div>

															<ButtonCollection>
																<DeleteButton
																	squared={true}
																	onClick={() => this.removePrize(i)}
																/>
															</ButtonCollection>
														</li>
													)
												})}
											</ul>
										)}

										<div class="gui_flexbox_auto gui_flex_nowrap gui_padded_children_low gui_not_in_top" style={{padding:'8px', background:'rgba(0, 0, 0, 0.1)'}}>
											<div class="gui_flexbox gui_flex_nowrap" style={{flexGrow:'1'}}>
												<div class="gui_flexbox_auto gui_flex_align_center" style={{lineHeight:'1em'}}>{i18n("Total winners")}:&nbsp;<strong>{this.state.sweep.config.num_winners}</strong></div>
											</div>
										</div>
									</div>
								</div>

								<Message
									title="Top tip!"
									_class={{ other:'in_bottom' }}
								>
									<p>{i18n("If you give away a range of prizes, we recommend listing them from lowest to highest value. The giveaway will award prizes in the order that you list them here. And it's always more exciting to save the best prize for last!")}</p>
								</Message>

								<ButtonCollection in_floating={true}>
									<SecondaryButton
										onClick={() => this.setState({ display_prizes_layer:false })}
									>Close</SecondaryButton>
								</ButtonCollection>
							</div>
						</FloatingLayer>
					)}

					{(this.state.display_popup_title) && (
						<FloatingLayer backButton={() => this.togglePopupTitle()} _class={{size:'small'}}>
							<div>
								<SectionTitle>Edit giveaway data</SectionTitle>

								<TextArea
									_class={{first:true}}
									name="title"
									model={this.state.sweep}
									change={this.changeSweep.bind(this)}
								>Title</TextArea>

								<div class="gui_not_in_top">
									<FieldLabel>Organizer</FieldLabel>

									<LabelSelector
										callback_set_label={this.setLabelSweep.bind(this)}
										display_on='inline'
										type="3"
										organizers={this.state.organizers}
										item_to_assign={item_label}
										is_agent_admin={this.props.is_agent_admin}
									/>
								</div>

								<ButtonCollection in_floating={true}>
									<SaveButton
										icon='knk-on'
										onClick={(e, cb) => this.save(cb)}
									>Save changes</SaveButton>
								</ButtonCollection>
							</div>
						</FloatingLayer>
					)}

					<SweepSidebar
						sweep={this.state.sweep}
						list_enabled={false}
						banners={this.props.banners}
						enable_make_sweep={false}
						display_posts={false}
						has_basic_subs={this.props.subsbasic}
						has_basicpro_subs={this.props.subspro}
						pricebasic={this.props.pricebasic}
						pricepro={this.props.pricepro}
						type="settings"
					/>

					{(this.state.display_save_message) && (
						<SaveResponseMessage
							status={this.state.display_save_status}
							message={<span dangerouslySetInnerHTML={{ __html:this.state.display_save_message}} />}
						/>
					)}
				</div>
			</Router>
		);
	}
}

export default injectIntl(SweepListLive);